import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgCart = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 2.03125C0 1.45977 0.449646 1 1.00855 1H2.9206C3.84511 1 4.66456 1.55 5.04697 2.375H22.3184C23.4236 2.375 24.2305 3.44922 23.9405 4.54063L22.2176 11.0848C21.8604 12.434 20.6627 13.375 19.297 13.375H7.17333L7.40026 14.5996C7.49271 15.0852 7.90873 15.4375 8.392 15.4375H20.5072C21.0661 15.4375 21.5158 15.8973 21.5158 16.4688C21.5158 17.0402 21.0661 17.5 20.5072 17.5H8.392C6.938 17.5 5.68992 16.443 5.42097 14.9863L3.25258 3.3418C3.22317 3.17852 3.08449 3.0625 2.9206 3.0625H1.00855C0.449646 3.0625 0 2.60273 0 2.03125ZM5.37895 20.9375C5.37895 20.6666 5.43112 20.3984 5.53249 20.1482C5.63386 19.898 5.78244 19.6706 5.96974 19.4791C6.15705 19.2876 6.37941 19.1356 6.62414 19.032C6.86887 18.9283 7.13116 18.875 7.39605 18.875C7.66094 18.875 7.92324 18.9283 8.16796 19.032C8.41269 19.1356 8.63506 19.2876 8.82236 19.4791C9.00967 19.6706 9.15825 19.898 9.25961 20.1482C9.36098 20.3984 9.41316 20.6666 9.41316 20.9375C9.41316 21.2084 9.36098 21.4766 9.25961 21.7268C9.15825 21.977 9.00967 22.2044 8.82236 22.3959C8.63506 22.5874 8.41269 22.7394 8.16796 22.843C7.92324 22.9467 7.66094 23 7.39605 23C7.13116 23 6.86887 22.9467 6.62414 22.843C6.37941 22.7394 6.15705 22.5874 5.96974 22.3959C5.78244 22.2044 5.63386 21.977 5.53249 21.7268C5.43112 21.4766 5.37895 21.2084 5.37895 20.9375ZM19.4987 18.875C20.0337 18.875 20.5467 19.0923 20.925 19.4791C21.3033 19.8659 21.5158 20.3905 21.5158 20.9375C21.5158 21.4845 21.3033 22.0091 20.925 22.3959C20.5467 22.7827 20.0337 23 19.4987 23C18.9637 23 18.4507 22.7827 18.0724 22.3959C17.6941 22.0091 17.4816 21.4845 17.4816 20.9375C17.4816 20.3905 17.6941 19.8659 18.0724 19.4791C18.4507 19.0923 18.9637 18.875 19.4987 18.875Z", fill: props.fill }));
});
export default SvgCart;
